import { color, rem, radius } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const borderBlockStyles = css`
  :host {
    align-items: center;
    background-color: ${color('blue', 100)};
    border: ${rem(1)} solid;
    border-color: ${color('blue', 300)};
    border-radius: ${radius('small')};
    color: ${color('black')};
    display: flex;
    gap: ${rem(8)};
    justify-content: space-between;
    padding: 0;
  }

  :host([type='success']) {
    background: ${color('green', 100)};
    border-color: ${color('green', 300)};
  }

  :host([type='error']) {
    background: ${color('red', 200)};
    border-color: ${color('red', 300)};
  }

  :host([type='tint']) {
    background: ${color('grey', 100)};
    border-color: ${color('grey', 300)};
  }

  :host([type='filter']) {
    background: ${color('teal', 100)};
    border-color: ${color('teal', 300)};
  }

  :host([size='small']) {
    font-size: ${rem(14)};
  }

  :host([size='small']) .main {
    padding: ${rem(6, 8)};
  }

  :host([size='small']) button {
    padding: ${rem(8)};
  }

  :host([size='tiny']) {
    font-size: ${rem(12)};
    font-weight: normal;
  }
  :host([size='tiny']) .main {
    padding: ${rem(4, 6)};
  }
  :host([size='tiny']) button {
    padding: ${rem(6)};
  }

  .main {
    padding: ${rem(12, 16)};
  }

  .title {
    font-weight: bold;
  }

  button {
    align-self: flex-start;
    display: flex;
    font-size: ${rem(16)};
    padding: ${rem(8)};
  }

  button:hover {
    color: ${color('blue', 500)};
  }

  :host([disabled]) {
    button {
      opacity: 0.2;
      pointer-events: none;
    }
  }
`;
